export function getIconsRating(ratingMax:number) {

  const iconArray  = Array.from({ length: ratingMax }, (key, index) => ({
    icon: "Icons_rating",
    point: index + 1
  }));
  return iconArray;
}
